<template>
  <div class="nav-search noselect" :style="{ height: `${viewportHeight}px` }">
    <div
      class="nav-search__search-container"
      :class="{ 'nav-search__search-container--active': active }"
      ref="search"
    >
      <div
        class="nav-search__search-background"
        :class="{ 'nav-search__search-background--active': active }"
        @click="() => handleActiveControl(false)"
      ></div>
      <div class="nav-search__ui">
        <NavigationSearchInterface
          :active="active"
          @close="handleActiveControl(false)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"

import NavigationSearchInterface from "./NavigationSearchInterface.vue"

export default {
  props: {
    active: Boolean
  },

  components: {
    NavigationSearchInterface
  },

  methods: {
    ...mapMutations("ui", ["SET_ROUTE_TRANSITION_STATE"]),
    ...mapActions("identity", ["SIGN_OUT"]),

    handleActiveControl(val) {
      this.$emit("activated", val)
    },

    onBeforeEnter(el) {
      // Force the browser to acknowledge the initial state
      // before the enter-from class is removed
      el.getBoundingClientRect()
    }

    // onTransitionAfterEnter(event) {
    //   this.debug.log("onTransitionAfterEnter", this.active, event)
    //   if (this.active) {
    //     this.$refs["searchInterface"].focusInput()
    //   }
    // }
  },

  computed: {
    ...mapGetters("breakpoints", [
      "GET_IS_BELOW_BREAKPOINT",
      "GET_IS_ABOVE_BREAKPOINT"
    ]),
    ...mapState("identity", ["authJWT"]),
    ...mapState("scroll", ["viewportHeight"])
  }
}
</script>

<style lang="scss">
.nav-search {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;

  &__search-container {
    position: absolute;
    overflow: hidden;
    // top: $nav-height-default;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // height: calc(100% - #{$nav-height-default});

    // @include media-breakpoint-up(md) {
    //   top: $nav-height-md;
    //   height: calc(100% - #{$nav-height-md});
    // }

    // @include media-breakpoint-up(lg) {
    //   top: $nav-height-lg;
    //   height: calc(100% - #{$nav-height-lg});
    // }

    // @include media-breakpoint-up(xl) {
    //   top: $nav-height-xl;
    //   height: calc(100% - #{$nav-height-xl});
    // }

    &--active {
      touch-action: none;
    }
  }

  &__search-background {
    background: rgba(getcolour(bleach_black), 0.3);
    backdrop-filter: saturate(75%);
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease;

    &--active {
      opacity: 1;
      pointer-events: all;
      cursor: pointer;
    }
  }

  &__ui {
    position: absolute;
    width: 100%;
    max-width: 500px;
    // overflow: hidden;
    right: 0;
    // pointer-events: none;

    top: 0;
    height: 100%;
  }

  &__ui-container {
    position: relative;
    top: 0;
    left: 100%;
    width: 100%;
    height: 100%;
    // transform: translateX(0);
    // transition: transform 0.2s ease;

    // &--active {
    //   transform: translateX(-100%);
    // }
  }
}
</style>
